export default function FeaturesSection({ features, maxHeight }) {
  return (
    <section className="tw-py-16 tw-px-4 tw-bg-gray-50" id="explore">
      <div className="tw-max-w-7xl tw-mx-auto">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8">
          {features.map((feature, index) => (
            <div key={index} className="tw-relative">
              <div
                className={`tw-absolute tw-inset-0 tw-bg-${feature.color}-100 tw-transform tw-rotate-1 tw-rounded-lg tw--z-10`}
              ></div>
              <div className="tw-bg-white tw-rounded-lg tw-overflow-hidden tw-shadow-md">
                <div className="tw-relative">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="tw-w-full tw-object-cover"
                    style={{ maxHeight: maxHeight || '300px' }}
                  />
                </div>
                <div className="tw-p-6">
                  <h3 className="tw-text-2xl tw-font-bold tw-mb-4">
                    {feature.title}
                  </h3>
                  <p className="tw-text-gray-700 tw-mb-6">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
